import { useQuery } from '@tanstack/react-query'
import { SectorComercial } from 'src/types';
import {HttpCacheOperacion} from "../../sistema/api/httpCacheOperacion";


export const useSectoresComerciales = (codSistema: number | undefined | null) => {
    const {
        data: sectores = [],
        isLoading,
        isError,
        error
    } = useQuery<SectorComercial[], Error>(
        {
            queryKey: ['sectores-comerciales', codSistema],
            queryFn: () => HttpCacheOperacion.getSectoresComercialesPorSistema(codSistema!),
            enabled: !!codSistema,
        }
    );

    return {
        sectores,
        loading: isLoading,
        isError,
        error
    };
};